import { AlertTriangle } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

export const SystemDisabledBanner = ({ systemLabelAr, systemLabelEn }) => {
  const { t, language } = useI18n();

  return (
    <div
      className={`fixed top-[84px] z-40 ${
        language === "en" ? "right-3 left-auto" : "left-3 right-auto"
      }`}
      data-testid="system-disabled-banner"
    >
      <div
        className="w-[min(420px,calc(100vw-1.5rem))] min-h-[120px] rounded-xl border border-destructive/65 bg-destructive/[0.18] px-4 py-3 shadow-[0_10px_24px_rgba(127,29,29,0.28)] backdrop-blur-sm"
      >
        <div className="flex items-start gap-2 text-destructive">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          <div>
            <div className="text-sm font-bold tracking-[0.01em]">
              {t("النظام غير مفعّل حاليًا", "System is currently OFF")}
            </div>
            <p className="mt-1 text-sm leading-6 text-destructive/95">
              {t(
                `يمكنك تعديل إعدادات ${systemLabelAr} الآن، لكن هذا النظام لن يعمل حتى يتم تفعيله.`,
                `You can configure ${systemLabelEn} now, but this system will not run until it is enabled.`,
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
